export { calculateAspectRatio } from "./calculateAspectRatio";
